import BG from '~/components/background';
import Form from "../../../../src/events/2020/08/event-survey/form";
import topImg from "../../../../src/events/2020/08/event-survey/images/top.png";
import midImg from "../../../../src/events/2020/08/event-survey/images/mid.png";
import bottomImg from "../../../../src/events/2020/08/event-survey/images/bottom.png";
import * as React from 'react';
export default {
  BG,
  Form,
  topImg,
  midImg,
  bottomImg,
  React
};